<div #buffer class="mt-32px"></div>
<footer #footer class="sticky-footer">
  <div class="sticky-footer-content">
    <ng-content></ng-content>
  </div>
</footer>
